// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"Row__ellipsis__2oB3L","flex-child-ellipsis":"Row__flex-child-ellipsis__2zZy6","multiplayer-cursor":"Row__multiplayer-cursor__2TvnM","row":"Row__row__1I8Rw"};